import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskCustomerNotificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-customer-notifications',
	path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications',
};
